import React from "react";
import { Route } from "react-router-dom";
import Home from "../pages/Home";
import TermsAndConditions from "../pages/TermsAndConditions";
import PrivacyPolicies from "../pages/PrivacyPolicies";
import ContactUs from "../pages/ContactUs";
import "../assets/css/home.css"

/**
 * @author Sarthak Sharma.
 * @since 28-12-2023.
 * @description Application URL Mapping.
 * @returns Routes
 */

const waitlistRouting = () => {
  return (
    <>
        <Route index path="/waitlist" element={<Home />} />
        <Route index path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route index path="/privacy-policy" element={<PrivacyPolicies />} />
        <Route index path="/contact-us" element={<ContactUs />} />
    </>
  );
};

export default waitlistRouting;